import { createPageDefinition, PageType, GetRouteAdTargeting } from 'common/routing/page-definition'
import { layout } from 'thewest/App.routing'
import { metrics } from 'component-library/__styling/settings'
import { regionalSiteConfig } from './regional-site-config'
import { TheWestSection } from 'component-library/__styling/settings/sections/thewest'

interface OurPapersRouteProps {
    section: TheWestSection
    getAdTargeting: GetRouteAdTargeting
}

export const getOurPapersRoute = ({
    section,
    getAdTargeting,
}: OurPapersRouteProps): PageType<typeof layout, TheWestSection> =>
    createPageDefinition<typeof layout, TheWestSection>(
        {
            heading: 'Regional Publications',
            hideHeading: true,
            pageType: 'static',
            adTargeting: getAdTargeting('home', section, 'our-papers'),
            section,
        },
        layout.composition({
            type: 'box',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                horizontalGutters: 'outerMargin',
                verticalGutters: ['outerMargin', 'unset'],
            },
            contentAreas: {
                main: [
                    layout.component({
                        type: 'breadcrumb',
                        props: {
                            title: 'Regional Publications',
                            enableHeaderTag: true,
                        },
                    }),
                ],
            },
        }),
        layout.composition({
            type: 'zeus',
            props: {
                containerWidth: metrics.thewest.mainContentWidth,
                horizontalGutters: true,
                hasBackgroundFill: true,
                stretchSelf: true,
            },
            contentAreas: {
                main: [
                    layout.nestedComposition({
                        type: 'box',
                        props: {
                            horizontalGutters: 'md',
                            verticalGutters: ['md', 'md'],
                            breakpoints: {
                                sm: {
                                    horizontalGutters: 'lg',
                                },
                                lg: {
                                    horizontalGutters: 'xl',
                                },
                            },
                        },
                        contentAreas: {
                            main: [
                                layout.component({
                                    type: 'our-publications',
                                    props: {},
                                }),
                            ],
                        },
                    }),
                ],
                sidebar: [
                    layout.component({
                        type: 'ad-unit',
                        props: {
                            noticePosition: 'none',
                            padding: [0, 0, metrics.thewest.margins.md, 0],
                            slot: {
                                id: 'sidebar-top',
                                size: 'desktopMrecHalfPage',
                                pageType: 'article',
                            },
                        },
                    }),
                    layout.component({
                        type: 'juliet',
                        props: {
                            cardType: {
                                type: 'landscape',
                                format: 'landscape-smallImage',
                            },
                            removeHorizontalGutters: true,
                            hideKicker: true,
                            contentIsTangential: true,
                            sectionHeader: {
                                heading: 'Local News',
                                section: 'generic',
                            },
                            dataDefinitionArgs: {
                                type: 'listing',
                                topics: [
                                    section !== 'default'
                                        ? regionalSiteConfig[section].mastheadTopic
                                        : 'news/wa',
                                ],
                                paging: {
                                    page: 1,
                                    pageSize: 3,
                                },
                            },
                        },
                    }),
                ],
            },
        })
    )
